import { createCtx } from "@tiny/utils/react/createContext";
import { DialogManagerContext } from "./DialogManager.types";

const [useDialogManager, DialogManagerProvider] =
  createCtx<DialogManagerContext>();

export { useDialogManager, DialogManagerProvider };
